import {
    Row, Col, Modal, List, Typography
} from 'antd';

import React from "react";
import { useTranslation } from "react-i18next";


const JobCardView = ({historyItem, setHistoryItem}) => {
  const { t } = useTranslation();
  const { Text } = Typography;

  function MaintenanceJobView({job}) {
    return (
             <div style={{height: 350,overflow: 'auto',}}>
              {
                job
                ?
                <div>
                  <Row>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Row><Text className='dp-field-label'>{t('field.reference')}</Text></Row>
                      <Row><Text>{job.reference}</Text></Row>
                      <Row><Text className='dp-field-label'>{t('field.odo_reading')}</Text></Row>
                      <Row><Text>{job.odoReading}</Text></Row>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Row><Text className='dp-field-label'>{t('field.supplier')}</Text></Row>
                      <Row><Text>{job.supplier}</Text></Row>
                      {
                        job.supplierReference
                        ?
                        <div>
                          <Row><Text className='dp-field-label'>{t('field.supplier_reference')}</Text></Row>
                          <Row><Text>{job.supplierReference}</Text></Row>
                        </div>
                        :
                        <></>
                      }
                    </Col>
                  </Row>
                  <Row><Text className='dp-field-label'>{t('field.work_completed')}</Text></Row>
                  <Row>
                    <List grid={{ gutter: 4, column: [job.items.length > 1?2:1] }}
                          dataSource={job.items}
                          renderItem={(item) => (
                            <List.Item>
                              {item.description}
                            </List.Item>
                          )}
                    />
                  </Row>
                </div>
                :
                <></>
              }
             </div>
            )
  }

return (
        <Modal className="std-portal-popup dp-wrap-card-title" 
               open={historyItem}
               title={t('title.details_for', {'0':(historyItem ? historyItem.reference : '')})}
               closable={true}
               keyboard={true}
               onCancel={() => {
                setHistoryItem(null);
               }}
               footer={<></>}
        >
          <MaintenanceJobView job={historyItem}/>
        </Modal>
       );
}

export default JobCardView;